module.exports = __webpack_public_path__ + "img/t4-teal.7e8845b4.png";